export default "__VITE_ASSET__1p91WPUO__"